import NetUtils from "../../utils/NetUtils";
import ArrayUtils from "../../utils/ArrayUtils";
import {dynamicSort} from "../../utils/SortUtils";

export default {
    findByCompany: async companyId => NetUtils.doPostWithParams('/UberServletBygglet', {
        method: 'findByCompany',
        manager: 'AcquisitionsupplierMgr',
        schema: 'byggletasset',
        postData: '' + companyId
    }).then(res => {
        const result = ArrayUtils.transformToArray(res.list0.acquisitionsupplier);
        result.sort(dynamicSort('name'))
        return result;
    }),

    findById: async id => NetUtils.doPostWithParams('/UberServletBygglet', {
        method: 'findById',
        manager: 'AcquisitionsupplierMgr',
        schema: 'byggletasset',
        postData: '' + id
    }).then(res => {
        return res.list0.acquisitionsupplier;
    }),
    update: model => NetUtils.doPostWithParams('/asset/UpdateAcquisitionsupplier', model),

}